// src/pages/ChatbotSettings/ChatbotSettings.js
import React, { useEffect, useState } from "react";
import axiosInstance from '../../utils/axiosInstance';
import Prompt from "./Prompt";

export default function ChatbotSettings() {


  return (
    <div>
      <main className="content page-website-configurations">
        <div className="container-fluid p-0">
          <Prompt/>
        </div>
      </main>
    </div>
  );
}
